export default __webpack_public_path__ + "static/media/man_with_book.a848871f.png";